import axios from 'axios'

import { reatailmediaApi as baseAPI } from './api'

const baseURL = `${baseAPI}/iframe-url`

type CreativeStudioResponse = { url: string }

export const getCreativeStudioUrl = (language: string) =>
  axios.get<CreativeStudioResponse>(`${baseURL}/creative-studio`, {
    params: { lang: language }
  })
